import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'store-card-stencil-list',
  template: `
    <div class="row row-gutters">
      @for (_ of cards; track _) {
        <div class="col col-xs-6 col-sm-4 col-md-3">
          <store-card-stencil></store-card-stencil>
        </div>
      }
    </div>
    `,
  styles: [
    `
      .row {
        display: flex;
        flex-wrap: wrap;
      }

      .row + .row-gutters {
        margin-top: 0;
      }

      .row-gutters {
        margin-top: -20px;
        margin-left: -20px;
      }

      .row-gutters > .col-flex {
        padding-top: 20px;
        padding-left: 20px;
      }

      .col-flex {
        position: relative;
        max-width: 100%;
        box-sizing: border-box;
        flex: 0 0 auto;
        width: 100%;
      }

      @media screen and (min-width: 480px) {
        .col-flex {
          width: 50%;
        }
      }

      @media screen and (min-width: 1200px) {
        .col-flex {
          width: 33.333333%;
        }
      }
    `,
  ],
  standalone: false,
})
export class CardListStencilComponent implements OnInit {
  @Input() numCards = 3;
  cards: number[] = [];

  ngOnInit(): void {
    for (let n = 0; n < this.numCards; n++) {
      this.cards.push(n);
    }
  }
}
